import { useQuery } from '@apollo/client'
import { SearchableCombobox, TSearchable } from '../../base/combobox'
import { SelectedManufacturerSelectorQuery } from './__generated__/selector_query'
import { SelectedQuery } from './selector_query'
import { useCombobox } from '@/helpers/useCombobox'

type AssetTypeManufacturer = SelectedManufacturerSelectorQuery['assetTypes']['manufacturers'][0]

interface Props {
  value: string
  onChange: (value: TSearchable | null) => void
  invalid: boolean
}

export const Selector = ({ value, onChange, invalid }: Props) => {
  const { data, loading } = useQuery<SelectedManufacturerSelectorQuery>(
    SelectedQuery,
  )
  const { pageInfo, items } = useCombobox<AssetTypeManufacturer>({
    pageInfo: undefined,
    querySelected: undefined,
    queryCollection: data?.assetTypes.manufacturers,
    buildSearchable: item => ({
      id: item,
      name: item,
    })
  })

  return (
    <SearchableCombobox
      data={items}
      fetchMore={() => false}
      includeBlank={false}
      invalid={invalid}
      loading={loading}
      moreToFetch={pageInfo.current?.hasNextPage}
      refetch={() => false}
      searchField="nameCont"
      value={items.find(d => d.id == value) || { id: value, name: value }}
      allowCustomInput
      onChange={onChange}
    />
  )
}
